import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import "./MyTask.css";
import { Modal, Button, Form } from "react-bootstrap";
import { CloudUpload } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useRef } from "react";
import _ from 'lodash';
import dayjs from 'dayjs';
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaStarOfLife } from "react-icons/fa6";
import { useEffect } from "react";
import MessageBox from "../MessageBox/MessageBox";


export default function EditTask() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();

              const Id = useSelector((state) => state.id);
    
    const [names, setNames] = useState([]);
       const [staffData, setStaffData] = useState([]);
    const [selectedNames, setSelectedNames] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [rows, setRows] = useState([]);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [approvePersons, setApprovePersons] = useState([]);  // Array of selected persons
    const [isApproveOpen, setIsApproveOpen] = useState(false);
    const approveDropdownRef = useRef(null);
    const [messageData, setMessageData] = useState(null);
    const [pageRefId, setpageRefId] = useState("")

    const [show, setShow] = useState(false);
    const [reason, setReason] = useState("");
    const [file, setFile] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const filteredNames = names.filter(staff =>
        staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    // Show Popup
    const handleShow = () => setShow(true);
    // Close Popup
    const handleClose = () => setShow(false);
    const [showButtons, setShowButtons] = useState(true);
    const [showUpdate, setShowUpdate] = useState(false);



    //   function formatDate(dateString) {
    //   const [year, month, day] = dateString.split("-");
    //   return `${day}-${month}-${year}`;
    // }

    // File Upload Function
    const handleFileChange1 = (e) => {
        setFile(e.target.files[0]);
    };



    const formatDateDate = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };





    function convertTo12Hour(timeStr) {
        if (!timeStr) return "";

        const [hourStr, minuteStr] = timeStr.split(":");
        const hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);

        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;

        return `${hour12.toString().padStart(2, "0")}:${minuteStr} ${ampm}`;
    }


    // Example:
    // Output: 05:48 PM


    // Submit Function
    // const handleSubmit = () => {
    //   console.log("Reason:", reason);
    //   console.log("File:", file);
    //   handleClose();
    //   navigate("/task");
    // };

    // const gotoviewEnquiry = (leadId) => {
    //   // navigate("/view_enquiry",{
    //   //   state: { leadId: leadId }
    //   // });

    //   let route = "";

    //   switch (taskDetails.taskName?.toLowerCase()) {
    //     case "enquiry":
    //       route = "/view_enquiry";
    //       break;
    //     case "installation":
    //       route = "/view_installation";
    //       break;
    //     case "recovery":
    //       route = "/recovery-view";
    //       break;
    //     case "compliant":
    //       route = "/compliant-view";
    //       break;
    //     default:
    //       route = "/task-view";
    //   }

    //   //Pass leadId through navigation state
    //   navigate(route, { state: { leadId } });
    // };

    //  const gotoviewEnquiry = (leadId,id) => {
    //   let route = "";
    //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

    //   switch (taskDetails.taskName?.toLowerCase()) {
    //     case "enquiry":
    //       route = "/view_enquiry";
    //       break;
    //     case "installation":
    //       route = "/view_installation";
    //       break;
    //     case "recovery":
    //       route = "/recovery-view";
    //       break;
    //     case "compliant":
    //       route = "/compliant-view";
    //       break;
    //     default:
    //       route = "/view_createtask";
    //   }

    //   if(id){
    //     navigate(route, { state: { id } });  
    //     return;
    //   }

    //   // Pass both leadId and activeTab as state
    //   navigate(route, { state: { leadId, activeTab } });
    // };



    //  const gotoviewEnquiry = (leadId, id) => {
    //   let route = "";
    //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

    //   switch (taskDetails.taskName?.toLowerCase()) {
    //     case "enquiry":
    //       route = "/view_enquiry";
    //       break;
    //     case "installation":
    //       route = "/view_installation";
    //       break;
    //     case "recovery":
    //       route = `/viewrecovery`;
    //       break;
    //     case "compliant":
    //       route = "/compliant-view";
    //       break;
    //     default:
    //       route = "/view_createtask";
    //   }


    //  const gotoviewEnquiry = (leadId,id) => {
    //   let route = "";
    //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

    //   switch (taskDetails.taskName?.toLowerCase()) {
    //     case "enquiry":
    //       route = "/view_enquiry";
    //       break;
    //     case "installation":
    //       route = "/view_installation";
    //       break;
    //     case "recovery":
    //       route = "/recovery-view";
    //       break;
    //     case "compliant":
    //       route = "/compliant-view";
    //       break;
    //     default:
    //       route = "/view_createtask";
    //   }

    //   if(id){
    //     navigate(route, { state: { id } });  
    //     return;
    //   }

    //   // Pass both leadId and activeTab as state
    //   navigate(route, { state: { leadId, activeTab } });
    // };



    // const gotoviewEnquiry = (leadId) => {
    //   let route = "";
    //   let activeTab = taskDetails.activeTab || "orderDetails";
    //   let taskName = taskDetails.taskName?.toLowerCase();

    //   let payload = { leadId, activeTab,hideButtons: true, taskId: taskDetails._id,  };

    //   switch (taskName) {
    //     case "enquiry":
    //       route = "/view_enquiry";
    //       payload.id = taskDetails.collectionId; // ✅ 👈 store collectionId as id
    //       break;
    //     case "installation":
    //       route = "/view_installation";
    //       payload.id = taskDetails._id;
    //       break;
    //     case "recovery":
    //       route = "/viewrecovery";
    //       payload.id = taskDetails._id;
    //       break;
    //     case "compliant":
    //       route = "/compliant-view";
    //       payload.id = taskDetails._id;
    //       break;
    //     default:
    //       route = "/view_createtask";
    //       payload.id = taskDetails._id;
    //   }

    //   navigate(route, { state: payload });
    // };

    // const handleAccept = () => {
    //   setShowButtons(false); // Hide Deny & Accept
    //   setShowUpdate(true); // Show Update Button
    // };


    const handleAccept = async () => {
        const result = await Swal.fire({
            title: "Confirm Acceptance",
            text: "Are you sure you want to accept this task?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Accept",
            cancelButtonText: "No, Cancel",
        });

        if (result.isConfirmed) {
            try {
                const now = new Date();
                const formattedDate = now.toLocaleDateString();
                const formattedTime = now.toLocaleTimeString();

                const payload = {
                    _id: taskDetails._id,
                    taskStatus: "Progress",
                    taskAccepted: {
                        taskAcceptedBy: staffName,
                        id: taskDetails._id,
                        acceptedDate: formattedDate,
                        acceptedTime: formattedTime,
                    },
                };

                const response = await axios.post(`${apiUrl}update-task-accept`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (response.data.success) {
                    Swal.fire({
                        title: "Task Accepted",
                        icon: "success",
                        confirmButtonText: "OK",
                    });
                    setShowButtons(false);
                    setShowUpdate(true);
                }
            } catch (error) {
                console.error("Error in handleAccept:", error);
                Swal.fire({
                    title: "Error",
                    text: "Something went wrong while accepting the task.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } else {
            Swal.fire({
                title: "Cancelled",
                text: "Task acceptance was cancelled.",
                icon: "info",
                confirmButtonText: "OK",
            });
        }
    };


    const [IsOpenTask, setIsOpenTask] = useState(false);

    // Handle file selection



    const handleSubmitUpdate = async (e) => {
        e.preventDefault();

        if (isEditMode) {
            // ✅ Check if there are any changes
            if (_.isEqual(taskDetails, originalComplaint)) {
                Swal.fire("No Changes", "No changes were made to update.", "info");
                return;
            }
        }

        const result = await Swal.fire({
            title: isEditMode ? "Update the changes?" : "Are you sure?",
            showCancelButton: true,
            confirmButtonText: isEditMode ? "Update" : "Submit",
        });

        if (result.isConfirmed) {
            try {
                if (isEditMode) {
                    await axios.post(
                        apiUrl + "update-lead-enquiry",
                        taskDetails,
                        { headers: { "Content-Type": "application/json" } }
                    );
                    Swal.fire("Updated!", "Data updated successfully", "success");
                }

                setIsEditable(false);
                setIsEditMode(false);
            } catch (error) {
                Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
            }
        }
    };

 

    const listView = () => {
        axios
            .post(apiUrl + "viewlead", {})
            .then((res) => {
                setRows(res.data.message);
            })
            .catch((error) => {
                console.error("Error fetching data", error);
            });
    }

    useEffect(() => {
        listView()
    }, []);

 // Fetch staff all data
       useEffect(() => {
          axios
            .post(
              apiUrl + "viewstaff",
      
              {}
            )
            .then((res) => {
              setStaffData(res.data.message);
      
              console.log(res.data.message);
             
            });
        }, [apiUrl]);
  
    const locate = useLocation();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isEditable, setIsEditable] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const id = useSelector((state) => state.id);

    const staffName = useSelector((state) => state.staffname);
    console.log(staffName)

    // to track update mode
    const [originalComplaint, setOriginalComplaint] = useState(null);
    const [taskDetails, settaskDetails] = useState({})
    console.log(taskDetails)
    const [originalData, setOriginalData] = useState({});


    const handleSubmit = async () => {
        try {
            if (!reason) {
                Swal.fire("Error", "Please enter a reason for denial", "error");
                return;
            }

            const formData = new FormData();
            formData.append("reason", reason);
            formData.append("file", file);
            formData.append("_id", taskDetails._id); // Task ID for identification
            formData.append("taskDeniedBy", staffName);

            const response = await axios.post(apiUrl + "deny-task", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.success) {
                Swal.fire("Success", "Task has been denied successfully", "success");
                handleClose();  // Close the modal
                navigate("/task");  // Navigate to the task page
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
        }
    };



    useEffect(() => {
        axios
            .post(apiUrl + "getdata-task", {
                leadId: locate.state?.id,
            })
            .then((res) => {
                settaskDetails(res.data.message);
                setOriginalData(res.data.message);
                setpageRefId(res.data.message._id) // Store original data for comparison
            });
    }, [locate.state?.id]);


    const [showStatusPopup, setShowStatusPopup] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        settaskDetails((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Check if the leadStatus is being changed
        if (name === "leadStatus") {
            setSelectedStatus(value);
            setIsOpenConverted(true);       // 👈 trigger popup
            // 👈 store selected status
        }
    };

    const handlePlanChange = (e) => {
        settaskDetails({
            ...taskDetails,
            enquiryplanDetails: {
                ...taskDetails.enquiryplanDetails,
                [e.target.name]: e.target.value
            }
        });
    };

    const [taskData, setTaskData] = useState({
        taskName: 'Enquiry',
        assignDateTime: '',
        taskType: '',
        taskPriority: '',
        deadline: '',
        time: '',
        assignedTo: [], // Array for multiple selections
        approvePerson: '',
        description: '',
        name: '',
        leadId: '',
        taskStatus: 'Open',
        assignedBy: ''
    });


    useEffect(() => {
        if (staffName) {
            setTaskData((prev) => ({ ...prev, assignedBy: staffName }));
        }
    }, [staffName]);

    console.log(taskData.staffName)

    const [isOpenAssign, setIsOpenAssign] = useState(false);

    const handleInputChange = (field, value) => {
        setTaskData(prev => ({
            ...prev,
            [field]: value
        }));
    };


    const [selectedFile, setSelectedFile] = useState(null);


    const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false)

    // Handle file selection
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    const [isOpenplan, setIsOpenplan] = useState(false);
    const [isOpenConverted, setIsOpenConverted] = useState(false);

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}-${month}-${year} / ${hours}:${minutes} ${ampm}`;
    }
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    useEffect(() => {
        axios.get(apiUrl + "get-staff-names")
            .then((res) => {
                if (res.data.message) {
                    setNames(res.data.message);  // names = array of objects like { _id, staffName }
                }
            })
            .catch((err) => {
                console.log("Error fetching staff names:", err);
            });

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Toggle dropdown open/close
    const toggleDropdown = () => {
        setIsOpen(prev => !prev);
    };

    // Checkbox change handler expects a staffName string
    const handleCheckboxChange = (staff) => {
        setSelectedNames(prev => {
            const exists = prev.find(item => item._id === staff._id);
            if (exists) {
                // remove staff
                return prev.filter(item => item._id !== staff._id);
            } else {
                // add staff
                return [...prev, staff];
            }
        });
    };


    // Display text: show staff names of selected IDs
    const displayText = selectedNames.length > 0
        ? selectedNames.map(item => item.staffName).join(', ')
        : 'Select names';
    const toggleApproveDropdown = () => {
        setIsApproveOpen(prev => !prev);
    };


    // const handleApproveCheckboxChange = (staff) => {
    
    //     setApprovePersons(prev => {
    //         const exists = prev.find(item => item._id === staff._id);
    //         if (exists) {
    //             // Remove staff
    //             return prev.filter(item => item._id !== staff._id);
    //         } else {
    //             // Add staff
    //             return [...prev, staff];
    //         }
    //     });
    // };
      const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };
    const approvePersonText = approvePersons.length > 0
        ? approvePersons.map(item => item.staffName).join(', ')
        : 'Select Approve Persons';

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
            if (approveDropdownRef.current && !approveDropdownRef.current.contains(event.target)) {
                setIsApproveOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

                if (response.status === 200 && Array.isArray(response.data.data)) {
                    setMessageData(response.data.data); // ✅ Only the array!
                } else {
                    console.error("Unexpected response structure:", response);
                    setMessageData([]); // fallback to empty array
                }
            } catch (error) {
                //   console.error("Error fetching messages:", error);
                setMessageData([]); // fallback to empty array
            }
        };

        fetchMessages();
    }, [apiUrl, pageRefId]);


    useEffect(() => {

        console.log(names,"ssssssssssssssssssssss")

        console.log(taskDetails,"zzzzzzzzzzzzzzzz")

        if (taskDetails?.assignedTo && names.length>0) {
            const assigned = names.filter(staff =>
                taskDetails.assignedTo.some(a => a._id === staff._id)
            );
            setSelectedNames(assigned);
        }
    }, [taskDetails, names]);


        useEffect(() => {

        console.log(names,"ssssssssssssssssssssss")

        console.log(taskDetails,"zzzzzzzzzzzzzzzz")

        if (taskDetails?.approvePerson && names.length>0) {
            const assigned = names.filter(staff =>
                taskDetails.approvePerson.some(a => a._id === staff._id)
            );
            setApprovePersons(assigned);
        }
    }, [taskDetails, names]);



    console.log(selectedNames)


    console.log("taskData.taskName =>", taskData.taskName);


const handleUpdateTask = () => {
  if (!taskDetails?._id) {
    console.log("ID not found in taskDetails");
    Swal.fire("Error", "Task ID is missing. Cannot update.", "error");
    return;
  }

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update the task details?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      const updateData = {
        taskName: taskDetails.taskName || "",
        taskType: taskDetails.taskType || "",
        taskPriority: taskDetails.taskPriority || "",
        description: taskDetails.description || "",
        assignedTo: selectedNames, 
        approvePerson:approvePersons,
        // ✅ selected staff
        deadline: taskDetails.deadline || "",
        taskStatus: taskDetails.taskStatus || "Open", // ✅ default fallback
      };

      axios
        .put(apiUrl + "edit-task", {
          id: taskDetails._id,
          updateData,
        })
        .then((res) => {
          if (res.data.message === "Task updated successfully") {
            setTaskData(res.data.data); // ✅ update local task state
            Swal.fire("Success", "Task details updated successfully!", "success");
          } else {
            throw new Error("Update failed");
          }
        })
        .catch((err) => {
          console.error("Error updating task:", err);
          Swal.fire("Error", "Failed to update task details.", "error");
        });
    } else {
      Swal.fire("Cancelled", "Task update cancelled.", "info");
    }
  });
};



    return (
        <>
            <Topbar />
            <Container className="mt-1">
                <form onSubmit={(e)=> {
                    e.preventDefault()
                    handleUpdateTask()
                }}>
                    <Row className="mb-4">
                        <Col md={4}>
                            <div className="ms-3">
                                <h3>Edit Task</h3>
                            </div>
                        </Col>
                        <Col md={8} className="text-end">
                            <div>

                                <button type="submit" className="blue-btn">Update</button>

                                {isEditMode && isEditable && (
                                    <>
                                        <button
                                            style={{ width: "100px" }}

                                            className="black-btn "
                                            type="button"
                                            onClick={() => {
                                                settaskDetails(JSON.parse(JSON.stringify(originalComplaint)));
                                                setIsEditable(false);
                                                setIsEditMode(false);
                                                setShowUpdate(true);

                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button className="blue-btn me-5 ms-2" type="submit">Submit</button>

                                    </>
                                )}

                            </div>

                        </Col>




                        {/* {taskDetails.taskStatus?.toLowerCase() === "open" && showButtons && (
              <>
                <Col className="mx-5 text-end">
                  <button
                    className="deny-btn me-3"
                    value="submit"
                    type="button" onClick={handleShow}
                  >
                    Deny
                  </button>
                  <Modal show={show} onHide={handleClose} centered>
                    <div className="reasonfor-Deny">
                      <Modal.Header closeButton >
                        <div className="mt-3">
                          <Modal.Title className="reason-heading ms-1 ">Reason</Modal.Title>
                        </div>
                      </Modal.Header>
                   
                      <div  >
                        <Form>

                          <Form.Group className="mb-3">
                            <Form.Control
                              as="textarea"
                              className="reason-body"
                              rows={4}
                              placeholder="Enter Reason for Denying Task"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                              style={{ textTransform: "capitalize", resize: "none" }}

                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <label
                              htmlFor="upload"
                              className="d-flex align-items-center gap-2 ms-3"
                            >
                              <CloudUpload />
                              Upload Image
                            </label>
                            <Form.Control
                              type="file"
                              id="upload"
                              style={{ display: "none" }}
                              onChange={handleFileChange1}
                            />
                          </Form.Group>
                        </Form>
                      </div>
                    
                      <div className="text-end me-3 mb-4">
                        <Button variant="primary" className="text-center" onClick={handleSubmit}>
                          Submit
                        </Button>
                      </div>
                  
                    </div>
                  </Modal>
                  <button
                    className="blue-btn px-4 text-white"
                    value="submit"
                    type="button"
                    onClick={handleAccept}
                  >
                    Accept
                  </button>
                </Col>
              </>
            )} */}


                        {/*           
          <Col className="mx-5 text-end">
            <button
              className="deny-btn me-3"
              value="submit"
              type="submit"
              onClick={handleShow}
            >
              Deny
            </button>
            <Modal show={show} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Reason</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Enter Reason for Denying Task"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <label
                      htmlFor="upload"
                      className="d-flex align-items-center gap-2"
                    >
                      <CloudUpload />
                      Upload Image
                    </label>
                    <Form.Control
                      type="file"
                      id="upload"
                      style={{ display: "none" }}
                      onChange={handleFileChange1}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
            <button
              className="blue-btn px-4 text-white"
              value="submit"
              type="submit"
              onClick={handleAccept}
            >
              Accept
            </button>
          </Col>  */}
                    </Row>

                    <Row className="task-create-details">
                        <div className="task-shadow">
                            <form >
                                <Row className="taskDetails">
                                    <Col>
                                        <h6 className="create-task-head">Task Details</h6>
                                    </Col>
                                    <Col className="text-end">
                                        <div className="">
                                            {/* {showUpdate && (
                      <button className="task-update" onClick={()=>gotoviewEnquiry(taskDetails?.leadId,taskDetails?._id)}>
                        Update
                      </button>
                    )} */}

                                            {/* {showUpdate || taskDetails?.taskStatus === "Progress" && (
  <button 
    className="task-update" 
    onClick={() => gotoviewEnquiry(taskDetails?.leadId, taskDetails?._id)}
  >
    Update
  </button>
)} */}



                                            {/* {(showUpdate || taskDetails?.taskStatus === "Progress" || taskDetails?.taskStatus === "Hold") && (
                        <button
                          className="task-update"
                          onClick={() => gotoviewEnquiry(taskDetails?.leadId, taskDetails?._id)}
                        >
                          Update
                        </button>
                      )} */}

                                        </div>
                                    </Col>
                                </Row>
                                <div className="taskdetailsfirst">
                                    <Row >
                                        <Col sm={3}>Task Created By - {taskDetails.assignedBy?.staffName}
                                        </Col>
                                        <Col>Created Date & Time - {formatDate(taskDetails.createdDate)}   </Col>
                                    </Row>
                                </div>
                                <div className="create-task-head-1">
                                    <Row className="g-5">
                                        <Col sm={12} md={6}>
                                            <Row>
                                                <Col sm={12} md={6} className="text-start">
                                                    <lable sm={12} className="rowdown ">
                                                        Name the Task
                                                    </lable>
                                                    <br />
                                                    <input
                                                        disabled
                                                        sm={12}
                                                        type="text"
                                                        required
                                                        value={taskDetails.taskName}
                                                        className="form-input-task"
                                                        placeholder="Enquiry"
                                                    />
                                                </Col>

                                                <Col sm={12} md={6} className="text-start">
                                                    <lable className="rowdown">Assign Date/Time</lable>
                                                    <br />
                                                    <input
                                                        // type="date"
                                                        className="form-input-task"
                                                        placeholder=""
                                                        value={formatDate(taskDetails.assignDateTime)}
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                            {/* <Row>
                      <Col sm={12} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Description
                        </lable>
                        <br />
                        <textarea
                          type="text"
                          value={taskDetails.description}
                          disabled
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                          className="box inputfield"
                          placeholder="Enter Installation Address"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Customer ID
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          value={taskDetails.leadId}

                          disabled
                           required
                          className="form-input-task"
                          placeholder="A21"
                        />
                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Name</lable>
                        <br />
                        <input
                          type="text"
                          className="form-input-task"
                          placeholder="Manikandan"
                          value={taskDetails.name}
                          disabled
                        />
                      </Col>
                    </Row> */}




                                            <Row>
                                                <Col sm={12} className="text-start">
                                                    <label>Description</label>
                                                    <textarea
                                                        value={taskDetails.description}
                                                        disabled
                                                        className="box inputfield"
                                                        style={{
                                                            resize: "none",
                                                            height: '180px',
                                                            width: "110%"
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            {['Enquiry', 'Installation', 'DueCollection', 'Complaint', 'Recovery'].includes(taskDetails.taskName) && (
                                                <>
                                                    <Row>
                                                        <Col sm={12} md={6} className="text-start">
                                                            <label>Customer ID</label>
                                                            <input
                                                                type="text"
                                                                value={taskDetails.leadId}
                                                                disabled
                                                                className="form-input-task"
                                                            />
                                                        </Col>
                                                        <Col sm={12} md={6} className="text-start">
                                                            <label>Name</label>
                                                            <br></br>
                                                            <input
                                                                type="text"
                                                                value={taskDetails.name}
                                                                disabled
                                                                className="form-input-task"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </Col>

                                        <Col sm={12} md={6}>
                                            <Row>
                                                {/* <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Task Type
                          </lable>
                          <br />
                          <select
                            value={taskDetails.taskType}
                            disabled
                            class="dropbtn form-input-select"
                          >
                            <option value="">Select</option>
                            <option className="" value="Once">
                              Once
                            </option>
                            <option className="" value="Daily">
                              Daily
                            </option>
                            <option className="" value="Weekly">
                              Weekly
                            </option>
                            <option className="" value="Monthly">
                              Monthly
                            </option>
                            <option className="" value="Custom">
                              Custom
                            </option>
                          </select>
                        </Col> */}

                                                <Col sm={12} md={6} className="text-start">
                                                    <lable className="rowdown">Task Priority</lable>
                                                    <br />
                                                    <select
                                                        value={taskDetails.taskPriority}
                                                        disabled
                                                        class="dropbtn form-input-select"
                                                    >
                                                        <option value="">Select</option>
                                                        <option className="" value="Low">
                                                            Low
                                                        </option>
                                                        <option className="" value="High">
                                                            High
                                                        </option>
                                                        <option className="" value="Immediate">
                                                            Immediate
                                                        </option>
                                                    </select>
                                                </Col>


 <Col sm={12} md={6} className="text-start">
                                                    <lable sm={12} className="rowdown ">
                                                        Deadline Date / Time
                                                    </lable>
                                                    <br />
                                                    <input
                                                        disabled
                                                        value={formatDate(taskDetails.deadline)}
                                                        sm={12}
                                                        // type="date"
                                                        required
                                                        className="form-input-task"
                                                        placeholder=""
                                                    />
                                                </Col>


                                                {/* <Col sm={12} md={6} className="text-start">
                                                    <lable sm={12} className="rowdown ">
                                                        Deadline Time
                                                    </lable>
                                                    <br />
                                                    <input
                                                        disabled
                                                        value={taskDetails.time}
                                                        sm={12}
                                                        // type="date"
                                                        required
                                                        className="form-input-task"
                                                        placeholder=""
                                                    />
                                                </Col> */}
                                            </Row>
                                            <Row className="mt-3">
                                                <Col xs={12} md={6} className="text-start">
                                                                                                                <label>Task Assign To</label>
                                                                                                                <br />
                                                                                                                <div
                                                                                                                  ref={dropdownRef}
                                                                                                                  style={{ position: "relative", width: "85%" }}
                                                                                                                >
                                                                                                                  <div
                                                                                                                    onClick={toggleDropdown}
                                                                                                                    style={{
                                                                                                                      padding: "10px",
                                                                                                                      border: "2px solid #a7a7a7",
                                                                                                                      borderRadius: "4px",
                                                                                                                      cursor: "pointer",
                                                                                                                      backgroundColor: "#fff",
                                                                                                                      display: "flex",
                                                                                                                      justifyContent: "space-between",
                                                                                                                      alignItems: "center",
                                                                                                                      marginTop: "10px",
                                                                                                                    }}
                                                                                                                  >
                                                                                                                    <span
                                                                                                                      style={{
                                                                                                                        overflow: "hidden",
                                                                                                                        textOverflow: "ellipsis",
                                                                                                                        whiteSpace: "nowrap",
                                                                                                                      }}
                                                                                                                    >
                                                                                                                      {displayText}
                                                                                                                    </span>
                                                                                                                    <span>{isOpen ? "▲" : "▼"}</span>
                                                                                                                  </div>
                                                                                        
                                                                                                                  {isOpen && (
                                                                                                                    <div
                                                                                                                      style={{
                                                                                                                        position: "absolute",
                                                                                                                        top: "100%",
                                                                                                                        left: 0,
                                                                                                                        right: 0,
                                                                                                                        marginTop: "5px",
                                                                                                                        border: "1px solid #ccc",
                                                                                                                        borderRadius: "4px",
                                                                                                                        backgroundColor: "#fff",
                                                                                                                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                                                                                                        zIndex: 1000,
                                                                                                                        maxHeight: "250px",
                                                                                                                        overflowY: "auto",
                                                                                                                      }}
                                                                                                                    >
                                                                                                                      {/* 🔍 Search Input */}
                                                                                                                      <input
                                                                                                                        type="text"
                                                                                                                        placeholder="Search staff..."
                                                                                                                        value={searchText}
                                                                                                                        onChange={(e) => setSearchText(e.target.value)}
                                                                                                                        style={{
                                                                                                                          width: "95%",
                                                                                                                          margin: "10px auto",
                                                                                                                          display: "block",
                                                                                                                          padding: "8px",
                                                                                                                          borderRadius: "4px",
                                                                                                                          border: "1px solid #ccc",
                                                                                                                        }}
                                                                                                                      />
                                                                                        
                                                                                                                      {/* Filtered Staff List */}
                                                                                                                      {staffData
                                                                                                                        .filter((staff) =>
                                                                                                                          [
                                                                                                                             "Marketing Executive",
                                                                                                       "Fiber Engineer,",
                                                                                                       "Super Admin",
                                                                                                       "Network Admin",
                                                                                                       "Accounts Admin",
                                                                                                       "Marketing Admin",
                                                                                                       "Network Engineer",
                                                                                                       "Marketing/Fiber",
                                                                                                       "Accountant",
                                                                                                       "Tele Calling",
                                                                                                                          ].includes(staff.designation)
                                                                                                                        )
                                                                                                                        .filter((staff) =>
                                                                                                                          staff.staffName
                                                                                                                            .toLowerCase()
                                                                                                                            .includes(searchText.toLowerCase())
                                                                                                                        ).length === 0 ? (
                                                                                                                        <div
                                                                                                                          style={{
                                                                                                                            padding: "10px",
                                                                                                                            color: "#888",
                                                                                                                            textAlign: "center",
                                                                                                                          }}
                                                                                                                        >
                                                                                                                          No Staffs found
                                                                                                                        </div>
                                                                                                                      ) : (
                                                                                                                        staffData
                                                                                                                          .filter((staff) =>
                                                                                                                            [
                                                                                                                            "Marketing Executive",
                                                                                                       "Fiber Engineer,",
                                                                                                       "Super Admin",
                                                                                                       "Network Admin",
                                                                                                       "Accounts Admin",
                                                                                                       "Marketing Admin",
                                                                                                       "Network Engineer",
                                                                                                       "Marketing/Fiber",
                                                                                                       "Accountant",
                                                                                                       "Tele Calling",
                                                                                                                            ].includes(staff.designation)
                                                                                                                          )
                                                                                                                          .filter((staff) =>
                                                                                                                            staff.staffName
                                                                                                                              .toLowerCase()
                                                                                                                              .includes(searchText.toLowerCase())
                                                                                                                          )
                                                                                                                          .map((staff) => (
                                                                                                                            <label
                                                                                                                              key={staff._id}
                                                                                                                              style={{
                                                                                                                                display: "flex",
                                                                                                                                alignItems: "center",
                                                                                                                                padding: "10px",
                                                                                                                                cursor: "pointer",
                                                                                                                                borderBottom: "1px solid #eee",
                                                                                                                              }}
                                                                                                                            >
                                                                                                                              <input
                                                                                                                                type="checkbox"
                                                                                                                                checked={selectedNames.some(
                                                                                                                                  (item) => item._id === staff._id
                                                                                                                                )}
                                                                                                                                onChange={() =>
                                                                                                                                  handleCheckboxChange(staff)
                                                                                                                                }
                                                                                                                                style={{ marginRight: "10px" }}
                                                                                                                                required
                                                                                                                              />
                                                                                                                              {staff.staffName || "(No Name)"}
                                                                                                                            </label>
                                                                                                                          ))
                                                                                                                      )}
                                                                                                                    </div>
                                                                                                                  )}
                                                                                                                </div>
                                                                                                              </Col>
                                                                                        
                                                                                                              <Col xs={12} md={6} className="text-start">
                                                                                                                <label>Approve Person</label>
                                                                                                                <br />
                                                                                                                <div
                                                                                                                  ref={approveDropdownRef}
                                                                                                                  style={{
                                                                                                                    position: "relative",
                                                                                                                    width: "85%",
                                                                                                                    marginTop: "15px",
                                                                                                                  }}
                                                                                                                >
                                                                                                                  <div
                                                                                                                    onClick={toggleApproveDropdown}
                                                                                                                    style={{
                                                                                                                      padding: "10px",
                                                                                                                      border: "2px solid #a7a7a7",
                                                                                                                      borderRadius: "4px",
                                                                                                                      cursor: "pointer",
                                                                                                                      backgroundColor: "#fff",
                                                                                                                      display: "flex",
                                                                                                                      justifyContent: "space-between",
                                                                                                                      alignItems: "center",
                                                                                                                      marginTop: "-5px",
                                                                                                                    }}
                                                                                                                  >
                                                                                                                    <span
                                                                                                                      style={{
                                                                                                                        overflow: "hidden",
                                                                                                                        textOverflow: "ellipsis",
                                                                                                                        whiteSpace: "nowrap",
                                                                                                                      }}
                                                                                                                    >
                                                                                                                      {approvePersonText}
                                                                                                                    </span>
                                                                                                                    <span>{isApproveOpen ? "▲" : "▼"}</span>
                                                                                                                  </div>
                                                                                        
                                                                                                                  {isApproveOpen && (
                                                                                                                    <div
                                                                                                                      style={{
                                                                                                                        position: "absolute",
                                                                                                                        top: "100%",
                                                                                                                        left: 0,
                                                                                                                        right: 0,
                                                                                                                        marginTop: "5px",
                                                                                                                        border: "1px solid #ccc",
                                                                                                                        borderRadius: "4px",
                                                                                                                        backgroundColor: "#fff",
                                                                                                                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                                                                                                        zIndex: 1000,
                                                                                                                        maxHeight: "250px",
                                                                                                                        overflowY: "auto",
                                                                                                                      }}
                                                                                                                    >
                                                                                                                      {/* 🔍 Search Input */}
                                                                                                                      <input
                                                                                                                        type="text"
                                                                                                                        placeholder="Search staff..."
                                                                                                                        value={searchTerm}
                                                                                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                                                                                        style={{
                                                                                                                          width: "100%",
                                                                                                                          padding: "8px 10px",
                                                                                                                          borderBottom: "1px solid #ccc",
                                                                                                                          boxSizing: "border-box",
                                                                                                                          outline: "none",
                                                                                                                          border: "none",
                                                                                                                        }}
                                                                                                                      />
                                                                                        
                                                                                                                      {/* 🧑‍💼 Filtered Staff List */}
                                                                                                                      {filteredNames.length === 0 ? (
                                                                                                                        <div
                                                                                                                          style={{
                                                                                                                            padding: "10px",
                                                                                                                            color: "#888",
                                                                                                                            textAlign: "center",
                                                                                                                          }}
                                                                                                                        >
                                                                                                                          No staff found
                                                                                                                        </div>
                                                                                                                      ) : (
                                                                                                                        filteredNames.map((staff) => (
                                                                                                                          <label
                                                                                                                            key={staff._id}
                                                                                                                            style={{
                                                                                                                              display: "flex",
                                                                                                                              alignItems: "center",
                                                                                                                              padding: "10px",
                                                                                                                              cursor: "pointer",
                                                                                                                              borderBottom: "1px solid #eee",
                                                                                                                            }}
                                                                                                                          >
                                                                                                                            <input
                                                                                                                              type="checkbox"
                                                                                                                              required
                                                                                                                              checked={approvePersons.some(
                                                                                                                                (item) => item._id === staff._id
                                                                                                                              )}
                                                                                                                              onChange={() =>
                                                                                                                                handleApproveCheckboxChange(staff)
                                                                                                                              }
                                                                                                                              style={{ marginRight: "10px" }}
                                                                                                                            />
                                                                                                                            {staff.staffName || "(No Name)"}
                                                                                                                          </label>
                                                                                                                        ))
                                                                                                                      )}
                                                                                                                    </div>
                                                                                                                  )}
                                                                                                                </div>
                                                                                                              </Col>
                                            </Row>
                                            <br />

                                            <Row>
                                               
                                                <Col sm={12} md={6} className="text-start">
                                                    <lable className="rowdown">Task Status</lable>
                                                    <br />
                                                    {/* <input style={{ backgroundColor: "#fbdc6e", color: "rgb(94, 94, 14)",textTransform:"capitalize" }}
                      type="button"
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      disabled
                    
                      value={taskDetails.taskStatus}

                    /> */}

                                                    <input
                                                        style={{
                                                            backgroundColor:
                                                                taskDetails.taskStatus?.toLowerCase() === "completed"
                                                                    ? "#28a745"
                                                                    : taskDetails.taskStatus?.toLowerCase() === "progress"
                                                                        ? "#6c757d"
                                                                        : "#fbdc6e",
                                                            color:
                                                                taskDetails.taskStatus?.toLowerCase() === "completed" || taskDetails.taskStatus?.toLowerCase() === "progress"
                                                                    ? "white"
                                                                    : "rgb(94, 94, 14)",
                                                            textTransform: "capitalize"
                                                        }}

                                                        type="button"
                                                        onClick={() => setIsOpenConverted(true)}
                                                        className="form-input converted-form"
                                                        disabled
                                                        value={taskDetails.taskStatus}
                                                    />


                                                    {IsOpenTask && (
                                                        <div className="overlay1-open">
                                                            <div className="modal1-open">
                                                                <Container>
                                                                    <button
                                                                        className="close-btn1"
                                                                        onClick={() => setIsOpenTask(false)}
                                                                    >
                                                                        <span style={{ fontSize: "20px" }}>
                                                                            &times;
                                                                        </span>
                                                                    </button>

                                                                    <div className="open-button border">
                                                                        <h5>Open</h5>
                                                                    </div>

                                                                    <textarea
                                                                        style={{
                                                                            textTransform: "capitalize",
                                                                            resize: "none",
                                                                        }}
                                                                        placeholder="Enter Description"
                                                                        className="open-textbox"
                                                                    />
                                                                    <div className="upload-section">
                                                                        <label className="upload-btn">
                                                                            <FiUpload className="upload-icon" />
                                                                            Upload Image
                                                                            <input
                                                                                type="file"
                                                                                accept="image/*"
                                                                                onChange={handleFileChange}
                                                                                hidden
                                                                            />
                                                                        </label>
                                                                        {selectedFile && (
                                                                            <p className="file-name">
                                                                                {selectedFile.name}
                                                                            </p>
                                                                        )}
                                                                    </div>

                                                                    <Row>
                                                                        <Col className="uploadbtn-install">
                                                                            <button
                                                                                type="button"
                                                                                className="blue-btn"
                                                                                onClick={() => setIsOpenTask(false)}
                                                                            >
                                                                                Upload
                                                                            </button>
                                                                        </Col>
                                                                    </Row>
                                                                </Container>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </form>
                        </div>
                    </Row>



                    {/* <form onSubmit={handleS
          ubmitUpdate}>  */}


                    {!["enquiry", "installation", "complaint", "dues", "recovery"].includes(taskDetails.taskName?.toLowerCase()) && (
                        <Row className="container ms-3 me-5">
                            {/* Message Box Column */}
                            <Col md={6} sm={12}>
                                <div>
                                    {Array.isArray(messageData) && messageData.length > 0 ? (
                                        messageData.map((msg) => (
                                            <MessageBox key={msg._id} message={msg} />
                                        ))
                                    ) : (
                                        <div className="text-muted">No messages available.</div>
                                    )}
                                </div>
                            </Col>

                            {/* Updates History Column */}
                            <Col md={6} sm={12}>
                                <div className="compact-updates-history">
                                    <div className="compact-updates-header">Updates History</div>
                                    {Array.isArray(messageData) && messageData.length > 0 ? (
                                        messageData.map((data, index) => (
                                            <div className="compact-update text-center" key={index}>
                                                <div className="compact-update-date text-center">
                                                    {data.updatesHistory?.date ? (
                                                        new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                                                        " - " +
                                                        new Date(data.updatesHistory.date).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true,
                                                        })
                                                    ) : (
                                                        "No date"
                                                    )}
                                                </div>
                                                <div className="compact-update-user text-center">
                                                    {data.updatesHistory?.staff?.name || "Unknown"}
                                                </div>
                                                <div
                                                    className="compact-update-status text-center"
                                                    style={{ color: data.colorCode || "#000000" }}
                                                >
                                                    {data.updatesHistory?.status || "No Status"}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-muted text-center">No update history available.</div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}




                </form>


            </Container>
        </>
    );
}